import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router";

const AiIndex = lazy(() => import("./pages/page"));

// Agents
const Agents = lazy(() => import("./pages/agents/page"));
const AgentNew = lazy(() => import("./pages/agents/new/page"));
const AgentDetail = lazy(() => import("./pages/agents/[id]/page"));

// Knowledge
const Knowledge = lazy(() => import("./pages/knowledge/page"));
const KnowledgeNew = lazy(() => import("./pages/knowledge/new/page"));
const KnowledgeDetail = lazy(() => import("./pages/knowledge/[id]/page"));

// Settings
const AiSettings = lazy(() => import("./pages/settings/page"));
const LlmProviders = lazy(() => import("./pages/settings/llm-providers/page"));

export const aiRoutes: RouteObject[] = [
  { index: true, Component: AiIndex },

  // Agents
  { path: "agents", Component: Agents },
  { path: "agents/new", Component: AgentNew },
  { path: "agents/:id", Component: AgentDetail },

  // Knowledge
  { path: "knowledge", Component: Knowledge },
  { path: "knowledge/new", Component: KnowledgeNew },
  { path: "knowledge/:id", Component: KnowledgeDetail },

  // Settings
  { path: "settings", Component: AiSettings },
  { path: "settings/ai-connections", element: <Navigate to="/connectors/mcp-tokens" replace /> },
  { path: "settings/llm-providers", Component: LlmProviders },
];
